import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DxDataGridComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
import { PickupserviceService } from '../../../services/pickupservice.service';
import { DropoffserviceService } from '../../../services/dropoffservice.service';
import { LoadpopupComponent } from '../../theme/expensemanagement/loadpopup/loadpopup.component';
import { SetupDataService } from '../../../services/setupdata.service';

@Component({
  selector: 'app-erpmissinginfopopup',
  templateUrl: './erpmissinginfopopup.component.html',
  styleUrls: ['./erpmissinginfopopup.component.scss'],
  providers: [ToastrService, SetupDataService]
})
export class ErpmissinginfopopupComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  salesOrder = {
    customer: '',
    customerId: '',
    orderNo: '',
    postingDate: '',
    salesLines: []
  };
  newRowPosition = 'last';
  loads = [];
  pickups: any[] = [];
  dropoffs: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ErpmissinginfopopupComponent>,
    private _toaster: ToastrService,
    public dialog: MatDialog,
    private _pickupService: PickupserviceService,
    private _dropoffService: DropoffserviceService,
    private _setupDataService: SetupDataService
  ) { }

  ngOnInit(): void {
    console.log("data informations", this.data);
    console.log("customer id", this.data.salesOrder.customerId);
    //this._setupDataService.getBc
    this._pickupService.getpickupData().subscribe((data) => {
      this.pickups = data.result;
    });
    this._dropoffService.getdroppoffData().subscribe((data) => {
      this.dropoffs = data.result;
    });
    if (this.data && this.data.salesOrder) {
      this.salesOrder = this.data.salesOrder;
    }
    if (this.data && this.data.loads) {
      console.log("customer id in loads", this.data.salesOrder.customerId);
      let loadData = this.data.loads.filter((load) => JSON.stringify(load.customerId) == JSON.stringify(this.data.salesOrder.customerId));
      console.log(loadData);
      this.loads = loadData;
    }
  }

  close() {
    this.dialogRef.close();
  }

  onCellClick(event) {
    if (event.columnIndex == 5 && event.rowType == "data") {
      const selectedLoad = this.loads.find((load) => load.loadNumber == event.data.loadNumber);
      let dialogConfig = Object.assign(
        { width: "1100px" },
        {
          data: {
            pickupData: this.pickups,
            loadData: this.loads,
            dropoffData: this.dropoffs,
            loadId: selectedLoad?._id,
          },
        }
      );
      let editDialogRef = this.dialog.open(LoadpopupComponent, dialogConfig);
      editDialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.setCellValue(event.rowIndex, data);
        }
      });
    }
  }

  setCellValue(rowIndex: any, value: any): void {
    const pickup = this.pickups.filter((p) => p.loadId?._id ? p.loadId._id == value : p.loadId == value);
    const selectedLoad = this.loads.find((load) => load._id == value);
    console.log(selectedLoad);
    this.grid.instance.cellValue(rowIndex, "loadNumber", selectedLoad?.loadNumber);
    this.grid.instance.cellValue(rowIndex, "unitPrice", selectedLoad["loadPrice"]);
    this.grid.instance.cellValue(rowIndex, "quantity", 1);
    this.grid.instance.cellValue(rowIndex, "amount", selectedLoad["loadPrice"]);
  }

  submit(salesOrderData) {
    this.grid.instance.saveEditData();
    console.log(salesOrderData);
    console.log(this.salesOrder);
    this.dialogRef.close(this.salesOrder);
    // // let isMissingLoadInfo = this.isAnyLoadMissing(this.salesOrder);
    // console.log(isMissingLoadInfo);
    // if (!isMissingLoadInfo) {
    // } else {
    //   this._toaster.error("Error", "Please ensure all sales lines have a load number.", { timeOut: 5000 });
    // }
  }

  isAnyLoadMissing(salesOrder: any): boolean {
    return salesOrder.salesLines.some((line: any) => !line.loadNumber);
  }
}
